var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.waterData.length)?_c('apex-chart',{attrs:{"type":"line","height":350,"options":_vm.chartOptions,"series":_vm.series}}):_c('div',{staticClass:"text-center"},[_vm._v("Không có dữ liệu")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }